import { Component } from '@angular/core';
import {CadastrosGeraisService} from "../../services/cadastros-gerais.service";
import {TipoDocumento} from "../models/tipo-documento";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-tipo-documento',
    templateUrl: './tipo-documento.component.html',
    styleUrl: './tipo-documento.component.css',
    standalone: false
})
export class TipoDocumentoComponent {
  loading = true;
  public colunas = ['Id', 'Descrição'];
  public linhas: any[] = [];
  listaDocumento: TipoDocumento[] = [];
  tipoDocumento = new TipoDocumento();
  adicionar = false;
  paginaAtual = 1;

  constructor(private cadastrosGeraisService: CadastrosGeraisService,
              private toastrService: ToastrService) {
    this.buscarLista();
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  public showModal() {
    this.adicionar = true;
  }

  public fecharModal(){
    this.adicionar = false;
  }

  public salvar(){
    this.loading = true;
    this.cadastrosGeraisService.adicionarTipoDocumento(this.tipoDocumento).subscribe(resultado => {
      if(resultado.sucesso){
        this.toastrService.success("Tipo de documento adicionado com sucesso!");
        this.fecharModal();
        this.linhas = [];
        this.buscarLista();
      }
      else{
        this.toastrService.error(resultado.errors[0].mensagem);
      }
    }, error => {
      this.toastrService.error(error);
    });
    this.loading = false;
  }

  public desativar(id: number){
    this.loading = true;
    Swal.fire({
      title: 'Deseja realmente desativar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.cadastrosGeraisService.desativarTipoDocumentos(id).subscribe(resultado => {
          if(resultado.sucesso){
            this.toastrService.success("Desativado com sucesso");
            this.buscarLista();
          }
        })
      }
    });
    this.loading = false;
  }

  private buscarLista(): void {
    this.cadastrosGeraisService.selecionarListaTipoDocumentos().subscribe(response => {
      if(response.sucesso)
      {
        this.listaDocumento = [];
        this.listaDocumento = response.dados;
      }
    });
    this.loading = false;
  }
}
